import { Component, Input } from '@angular/core';
import { Widget, WidgetEntry, WidgetEntryWithData, WidgetType, WidgetWithData } from '@models/widget/widget.model';

@Component({
  standalone: false,
  selector: 'app-widget-renderer',
  templateUrl: './widget-renderer.component.html',
  styleUrls: ['./widget-renderer.component.scss'],
})
export class WidgetRendererComponent {
  @Input({ required: true }) widget!: Widget | WidgetWithData;
  @Input() isPreview = false;

  get renderWidget(): WidgetWithData {
    return {
      ...this.widget,
      entries: this.getEntries(this.widget).map((entry) => ({
        ...entry,
        data: 'data' in entry && Array.isArray(entry.data) ? entry.data : [],
      })),
    };
  }

  get renderType(): WidgetType {
    return this.widget.widgetType;
  }

  get isUnconfigured(): boolean {
    return !this.isPreview && this.getEntries(this.widget).some((entry) => entry.dataSourceType === 'DEVICE' && !entry.deviceId);
  }

  private getEntries(widget: Widget | WidgetWithData): Array<WidgetEntry | WidgetEntryWithData> {
    return widget.entries ?? [];
  }
}
